import { render, staticRenderFns } from "./nursing_care.vue?vue&type=template&id=2ed4eabb&scoped=true"
import script from "./nursing_care.vue?vue&type=script&lang=js"
export * from "./nursing_care.vue?vue&type=script&lang=js"
import style0 from "./nursing_care.vue?vue&type=style&index=0&id=2ed4eabb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed4eabb",
  null
  
)

export default component.exports